export default "__VITE_ASSET__CyP4C_ui__"